"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Logo = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _CivicClerk = _interopRequireWildcard(require("./CivicClerk"));

var _CivicEngageCentral = _interopRequireWildcard(require("./CivicEngageCentral"));

var _CivicEngageEvolve = _interopRequireWildcard(require("./CivicEngageEvolve"));

var _CivicHR = _interopRequireWildcard(require("./CivicHR"));

var _CivicOptimize = _interopRequireWildcard(require("./CivicOptimize"));

var _CivicPlus = _interopRequireWildcard(require("./CivicPlus"));

var _CivicReady = _interopRequireWildcard(require("./CivicReady"));

var _CivicRec = _interopRequireWildcard(require("./CivicRec"));

var _CivicService = _interopRequireWildcard(require("./CivicService"));

var _Preamble = _interopRequireWildcard(require("./Preamble"));

var _react = _interopRequireDefault(require("react"));

var _SeeClickFix = _interopRequireWildcard(require("./SeeClickFix"));

var Logo = function Logo(_ref) {
  var product = _ref.product,
      white = _ref.white,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["product", "white"]);

  if (product === "CivicClerk") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicClerk.CivicClerkLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicClerk.default, otherProps);
    }
  }

  if (product === "CivicEngage Evolve") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageEvolve.CivicEngageEvolveLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageEvolve.default, otherProps);
    }
  }

  if (product === "CivicEngage Central") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageCentral.CivicEngageCentralLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageCentral.default, otherProps);
    }
  }

  if (product === "CivicHR") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicHR.CivicHRLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicHR.default, otherProps);
    }
  }

  if (product === "CivicOptimize") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicOptimize.CivicOptimizeLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicOptimize.default, otherProps);
    }
  }

  if (product === "CivicPlus") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicPlus.CivicPlusLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicPlus.default, otherProps);
    }
  }

  if (product === "CivicReady") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicReady.CivicReadyLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicReady.default, otherProps);
    }
  }

  if (product === "CivicRec") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicRec.CivicRecLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicRec.default, otherProps);
    }
  }

  if (product === "CivicService") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicService.CivicServiceLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicService.default, otherProps);
    }
  }

  if (product === "SeeClickFix") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_SeeClickFix.SeeClickFixLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_SeeClickFix.default, otherProps);
    }
  }

  if (product === "Preamble") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_Preamble.PreambleLogoWhite, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_Preamble.default, otherProps);
    }
  }

  return null;
};

exports.Logo = Logo;
Logo.defaultProps = {
  role: "img"
};
var _default = Logo;
exports.default = _default;